var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoStockAdded(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 153,
    height: 200,
    viewBox: "0 0 153 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cu4htkyy0a",
    d: "M0 200h153V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m61.058 154.874 5.91 7.957s4.185-1.312 4.02-5.332c-.164-4.02-3.119-8.777-3.119-8.777l-6.811 6.152zM23.716 93.842s-7.55 1.313-8.536 3.446c-.985 2.132-2.954 3.937-2.79 5.906.165 1.97 11.326 79.407 11.326 79.407s3.118 4.594 7.55 4.594 5.089-1.477 5.089-1.477l.327-52.993-19.532-20.343S16 99.585 22.895 97.616c6.894-1.969.82-3.774.82-3.774M28.312 92.038l2.298-6.727 10.505-7.546s2.626-.985 4.431.163l3.611 2.298 28.726-.329s10.176 1.476 11.981 6.89c1.806 5.414 0 9.024 0 9.024L47.352 88.1s-5.58-.164-7.223-.82c-1.64-.656 0 1.64-.82 2.46-.82.822-2.626 2.134-3.282 1.97-.657-.165-2.299-1.148-2.299-1.148s-.656 1.476-5.416 1.476M93.147 31.334l-14.772-10.5-3.775 14.11 9.192 7.218z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.679 115.658c-6.745 10.01-17.426 14.928-27.883 12.814l-38.324-7.726c-.035-.007-.067.003-.102 0l-4.513-7.08a.988.988 0 0 0-1.666 1.06l20.89 32.763-8.184 7.33-40.432-42.657v-4.912c0-5.94 4.834-10.772 10.775-10.772H89.7c.139 0 .27-.03.39-.08 3.191 6.94 9.944 11.754 17.78 12.305l14.795 1.04-3.986 5.915z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.616 27.297A5.165 5.165 0 0 0 8.45 32.46v9.69a5.165 5.165 0 0 0 5.166 5.162h13.219v5.743l5.744-5.743h2.385a5.164 5.164 0 0 0 5.165-5.162v-9.69a5.164 5.164 0 0 0-5.165-5.163H13.616z",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11 198.962H89.331a5.902 5.902 0 0 1-5.903-5.9v-55.904c0-3.258 2.642-5.9 5.903-5.9h56.777a5.901 5.901 0 0 1 5.903 5.9v55.903c0 3.26-2.643 5.901-5.903 5.901",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11 198.962H89.331a5.902 5.902 0 0 1-5.903-5.9v-55.904c0-3.258 2.642-5.9 5.903-5.9h56.777a5.901 5.901 0 0 1 5.903 5.9v55.903c0 3.26-2.643 5.901-5.903 5.901z",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11 131.258H89.331a5.901 5.901 0 0 0-5.903 5.9v5.585h68.583v-5.585c0-3.258-2.643-5.9-5.903-5.9",
    fill: "#080717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.11 131.258H89.331a5.901 5.901 0 0 0-5.903 5.9v5.585h68.583v-5.585c0-3.258-2.643-5.9-5.903-5.9z",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.466 137.418a1.892 1.892 0 1 1-3.783 0 1.892 1.892 0 0 1 3.783 0M100.097 137.418a1.892 1.892 0 1 1-3.783 0 1.892 1.892 0 0 1 3.783 0M107.729 137.418a1.892 1.892 0 1 1-3.784 0 1.892 1.892 0 0 1 3.784 0",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#080717",
    strokeWidth: 2.96,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M98.188 155.868h39.065M98.188 169.321h19.416M98.188 162.431h14.821M119.531 162.431h8.897"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.533 25.956s-9.277-.138-12.66-3.312c-2.674-2.51-4.063-8.783 2.662-9.514 6.723-.731 10.208 1.13 7.602 3.1-2.606 1.967-6.874-3.019-1.619-9.295C57.773.66 63.362-3.148 66.929 4.625c3.568 7.773 5.31 14 .137 8.956C61.893 8.538 63.582 1.13 70.813.151c7.229-.98 11.705 2.902 10.955 9.285-.752 6.384 4.49 15.905 4.49 15.905l-10.586-1.26s-16.002 6.476-19.14 1.875",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.126 22.313c-1.117-5.591-6.741-7.343-7.722-3.979-.981 3.364 1.613 6.602 1.613 6.602s-7.494 1.618-11.468-4.626c-1.962 1.71-4.419 3.249-7.238 4.471l6.08 12.993 3.032-1.488 7.56 5.437 5.793-7.604s3.468-6.214 2.35-11.806",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m53.311 24.781 6.08 12.992 3.031-1.487 7.561 5.438 5.793-7.606"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.783 27.558s1.04-1.984 3.604-1.727",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.625 27.886a.752.752 0 1 1-1.28.79.752.752 0 0 1 1.28-.79",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m75.184 35.608 7.564 5.969M82.549 23.471 93.1 32.027M124.17 109.274l-4.672 6.934c-6.994 10.38-18.013 15.426-28.896 13.233l-38.326-7.728"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47.024 114.196 21.338 33.469-9.52 8.53-41.364-43.64v-5.306c0-6.492 5.267-11.757 11.762-11.757H89.7",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.807 150.103h13.787v33.942c0 2.85-5.138 3.322-7.66.765l-9.061-21.306s8.04-3.193 2.934-13.401",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.02 150.103v33.942c0 2.85-2.938 3.322-4.739.765l-8.41-21.062s6.948-3.437 3.3-13.645h9.849z",
    fill: "#6176F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.807 150.103h13.787v33.942c0 2.85-5.138 3.322-7.66.765l-9.061-21.306s8.04-3.193 2.934-13.401zM66.873 163.504l-6.39-8.293M69.807 150.103l-1.445-2.111",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m77.882 47.395 15.822-16.543s29.287-2.316 34.337 27.13c5.049 29.449-2.694 51.948-2.694 51.948l-17.477-1.227A21.217 21.217 0 0 1 88.725 92.5L77.882 47.395z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m76.35 79.876-27.486.258-3.358-2.062c-1.772-1.088-4.096-.786-5.55.72l-9.195 6.245-2.204 6.801s4.631 2.062 6.813-4.22",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.534 87.617s1.642-.492 2.79-1.476M38.488 85.977c3.245 2.607 8.785 2.098 8.785 2.098l40.786 7.418",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "11hzu9vnpb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cu4htkyy0a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#11hzu9vnpb)",
    d: "M23.059 96.149h40.05v-3.953H23.06z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#11hzu9vnpb)",
    d: "m5.486 60.391 17.817 35.852 3.541-1.758L9.027 58.633zM73.614 75.805s8.53 12.14 19.37 12.14c.984 0 15.667-20.95 15.429-29.203-.173-5.962-4.596-21.329-20.354-12.469L73.614 75.805z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.983 87.946c.737-.654 15.668-20.95 15.43-29.204",
    stroke: "#FFF",
    strokeWidth: 1.973,
    mask: "url(#11hzu9vnpb)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#11hzu9vnpb)",
    d: "M98.236 31.836 86.089 49.883l-8.206-2.488 2.953 11.347"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.795 199.013-33.433-.25c-2.807-.022-3.234-5.081-.697-7.544l21.054-8.76s3.085 7.936 13.178 2.986l-.102 13.568z",
    fill: "#FFF",
    mask: "url(#11hzu9vnpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.821 195.496-33.432-.252c-2.808-.02-3.25-2.914-.72-4.669l20.81-8.12s3.333 6.863 13.415 3.35l-.073 9.691z",
    fill: "#6176F4",
    mask: "url(#11hzu9vnpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36.897 185.445-.102 13.568-33.433-.25c-2.807-.022-3.234-5.081-.697-7.544l21.054-8.76s3.085 7.936 13.178 2.986zM36.519 185.071v-52.16M35.862 178.509h-11.49",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#11hzu9vnpb)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.719 182.46-11.123-76.673c-.887-6.122 3.862-11.607 10.05-11.607M34.385 90.078s.813 1.723 2.133 1.641c2.627-.165 3.12-4.43 3.12-4.43",
    stroke: "#000",
    strokeWidth: 1.973,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    mask: "url(#11hzu9vnpb)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoStockAdded);
export default __webpack_public_path__ + "static/media/no-stock-added.45413065b53b45b3ad9e1ad82f096c54.svg";
export { ForwardRef as ReactComponent };